// 题目相关的API函数
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { questionApi } from '../utils/axios';
import { localApi } from '../utils/axios';

// API基础URL - 外部题库API
const QUESTION_API_URL = 'https://timu-api.flybirdai.com';

// 获取考试试卷 - 根据比赛/考级名称、编程语言和日期获取指定试卷
export const getExamByContest = async (contestName, languageName, contestDate) => {
  try {
    const response = await axios.post(`${QUESTION_API_URL}/api/by-contest`, {
      contest_name: contestName,
      language_name: languageName,
      contest_date: contestDate
    });
    return response.data;
  } catch (error) {
    console.error('获取指定考试试卷失败:', error);
    throw error;
  }
};

// 获取随机组卷 - 根据指定参数随机组卷
export const getRandomExam = async (params = {}) => {
  try {
    // 默认值处理
    const requestParams = {
      choice_count: params.choiceCount || 1,
      judge_count: params.judgeCount || 1, 
      coding_count: params.codingCount || 1,
      // 可选参数
      min_difficulty: params.minDifficulty,
      max_difficulty: params.maxDifficulty,
      language_id: params.languageId
    };
    
    const response = await axios.post(`${QUESTION_API_URL}/api/random-paper`, requestParams);
    return response.data;
  } catch (error) {
    console.error('获取随机试卷失败:', error);
    throw error;
  }
};

// 提交试卷
export const submitPaper = async (paperId, answers) => {
  try {
    const response = await axios.post(`${QUESTION_API_URL}/api/submit-paper`, {
      paper_id: paperId,
      answers: answers
    });
    return response.data;
  } catch (error) {
    console.error('提交试卷失败:', error);
    throw error;
  }
};

// 获取比赛/考级列表
export const getContests = async () => {
  try {
    const response = await axios.get(`${QUESTION_API_URL}/api/contests`);
    return response.data;
  } catch (error) {
    console.error('获取比赛列表失败:', error);
    throw error;
  }
};

// 获取指定比赛下的编程语言
export const getLanguagesByContest = async (contestName) => {
  try {
    const response = await axios.get(`${QUESTION_API_URL}/api/contests/${encodeURIComponent(contestName)}/languages`);
    return response.data;
  } catch (error) {
    console.error('获取语言列表失败:', error);
    throw error;
  }
};

// 获取指定比赛和语言下的届次/日期列表
export const getInstancesByContestAndLanguage = async (contestName, languageName) => {
  try {
    const response = await axios.get(
      `${QUESTION_API_URL}/api/contests/${encodeURIComponent(contestName)}/languages/${encodeURIComponent(languageName)}/instances`
    );
    return response.data;
  } catch (error) {
    console.error('获取届次列表失败:', error);
    throw error;
  }
};

// 获取试卷详情
export const getPaperById = async (paperId) => {
  try {
    const response = await axios.get(`${QUESTION_API_URL}/api/papers/${paperId}`);
    return response.data;
  } catch (error) {
    console.error('获取试卷内容失败:', error);
    throw error;
  }
};

// 创建练习和保存试卷到本地数据库
export const saveExerciseWithQuestions = async (exerciseData) => {
  try {
    // 从exerciseData中提取questions字段，其余部分作为exercise对象
    const { questions, ...exercise } = exerciseData;
    
    const response = await localApi.post(`${API_BASE_URL}/exercises/with-questions`, {
      exercise: exercise,
      questions: questions || exerciseData.questions // 兼容两种调用方式
    });
    return response.data;
  } catch (error) {
    console.error('保存练习和题目失败:', error);
    throw error;
  }
};

// 获取题目列表
export const getQuestions = async (params = {}) => {
  try {
    const response = await questionApi.get('/api/questions', { params });
    return response.data;
  } catch (error) {
    console.error('获取题目列表失败:', error);
    throw error;
  }
};

// 获取单个题目详情
export const getQuestion = async (id) => {
  try {
    const response = await questionApi.get(`/api/questions/${id}`);
    return response.data;
  } catch (error) {
    console.error('获取题目详情失败:', error);
    throw error;
  }
};  
